import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';

const fonte = "'DM Sans',system-ui,sans-serif";
const labelStyle = { color: '#6B7A8D', fontSize: '11px', fontWeight: '600', display: 'block', marginBottom: '5px', textTransform: 'uppercase', letterSpacing: '0.3px' };
const inputStyle = { width: '100%', padding: '10px 12px', background: '#F4F6F9', border: '0.5px solid rgba(26,58,92,0.15)', borderRadius: '8px', color: '#1C2533', fontSize: '14px', fontFamily: fonte, boxSizing: 'border-box', outline: 'none' };

export function AuthShell({ titulo, subtitulo, children }) {
  return (
    <div style={{ minHeight: '100vh', background: '#F0F3F7', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: fonte }}>
      <div style={{ width: '100%', maxWidth: '400px', padding: '0 20px' }}>
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
            <div style={{ width: '44px', height: '44px', background: '#1A3A5C', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '700', fontSize: '18px', color: '#fff' }}>A+</div>
            <span style={{ fontSize: '28px', fontWeight: '700', color: '#1A3A5C', letterSpacing: '-0.5px' }}>AutoMais</span>
          </div>
          <div style={{ fontSize: '14px', color: '#6B7A8D' }}>Sistema de Gestão</div>
        </div>
        <div style={{ background: '#fff', borderRadius: '12px', border: '0.5px solid rgba(26,58,92,0.12)', padding: '32px' }}>
          <div style={{ fontSize: '18px', fontWeight: '700', color: '#1C2533', marginBottom: '6px' }}>{titulo}</div>
          <div style={{ fontSize: '13px', color: '#6B7A8D', marginBottom: '24px' }}>{subtitulo}</div>
          {children}
        </div>
        <div style={{ textAlign: 'center', marginTop: '20px', fontSize: '13px' }}>
          <Link to='/login' style={{ color: '#1A3A5C', fontWeight: '600', textDecoration: 'none' }}>← Voltar para o login</Link>
        </div>
      </div>
    </div>
  );
}

export const authStyles = { labelStyle, inputStyle, fonte };

export function BotaoPrimario({ loading, children, textoLoading }) {
  return (
    <button type='submit' disabled={loading}
      style={{ width: '100%', padding: '12px', background: loading ? '#6B7A8D' : '#1A3A5C', border: 'none', borderRadius: '8px', color: '#fff', fontSize: '15px', fontWeight: '600', cursor: loading ? 'not-allowed' : 'pointer', fontFamily: fonte }}>
      {loading ? textoLoading : children}
    </button>
  );
}

export function Aviso({ tipo, children }) {
  const cores = tipo === 'erro'
    ? { background: '#FDECEA', border: '0.5px solid #C0392B', color: '#C0392B' }
    : { background: '#E8F6EE', border: '0.5px solid #1E8449', color: '#1E8449' };
  return <div style={{ ...cores, borderRadius: '8px', padding: '10px 14px', marginBottom: '16px', fontSize: '13px', lineHeight: 1.5 }}>{children}</div>;
}

export default function RecuperarSenha() {
  const [email, setEmail] = useState('');
  const [enviado, setEnviado] = useState('');
  const [erro, setErro] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErro('');
    try {
      const r = await api.post('/auth/recuperar-senha', { email });
      setEnviado(r.data?.message || 'Se o email estiver cadastrado, você receberá um link para redefinir a senha.');
    } catch (err) {
      setErro(err.response?.data?.error || 'Não foi possível enviar agora. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell titulo='Esqueci minha senha' subtitulo='Informe seu email e enviaremos um link para criar uma nova senha'>
      {enviado ? (
        <Aviso tipo='ok'>{enviado} Verifique também a caixa de spam. O link expira em 1 hora.</Aviso>
      ) : (
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '20px' }}>
            <label style={labelStyle}>Email</label>
            <input type='email' value={email} onChange={e => setEmail(e.target.value)} placeholder='seu@email.com' required autoFocus style={inputStyle} />
          </div>
          {erro && <Aviso tipo='erro'>{erro}</Aviso>}
          <BotaoPrimario loading={loading} textoLoading='Enviando...'>Enviar link de recuperação</BotaoPrimario>
        </form>
      )}
    </AuthShell>
  );
}
